import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
export default class extends ApplicationController {
  // static targets = [ "hm0_output" ]
  connect() {
    super.connect();
    // add your code here, if applicable
    console.log("hello fx_ticket from StimulusJS");
  }

  write_message() {
    if (document.getElementById("fx_discution_message").value != "") {
      document.getElementById("fx_discution_submit").disabled = false;
    } else {
      document.getElementById("fx_discution_submit").disabled = true;
    }
  }

  // get current_app() {
  //   return this.data.get('app')
  // }
  // get conge_id() {
  //   return this.data.get('congeid')
  // }
  // get url_solution(){
  //   return this.data.get('urlsolution')
  // }

  /* Reflex specific lifecycle methods.
   *
   * For every method defined in your Reflex class, a matching set of lifecycle methods become available
   * in this javascript controller. These are optional, so feel free to delete these stubs if you don't
   * need them.
   *
   * Important:
   * Make sure to add data-controller="conge" to your markup alongside
   * data-reflex="Conge#dance" for the lifecycle methods to fire properly.
   *
   * Example:
   *
   *   <a href="#" data-reflex="click->Conge#dance" data-controller="conge">Dance!</a>
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Conge#dance"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  // Assuming you create a "Conge#dance" action in your Reflex class
  // you'll be able to use the following lifecycle methods:

  // beforeDance(element, reflex, noop, reflexId) {
  //  element.innerText = 'Putting dance shoes on...'
  // }

  // danceSuccess(element, reflex, noop, reflexId) {
  //   element.innerText = 'Danced like no one was watching! Was someone watching?'
  // }

  // danceError(element, reflex, error, reflexId) {
  //   console.error('danceError', error);
  //   element.innerText = "Couldn't dance!"
  // }
}
